
import { Component, Vue, Prop } from "vue-property-decorator";
import { TTask_Table } from "@/models/tasks_services";
import { SMAdditionalInfo, SMTasksServices, SMUser } from "@/store";
import WidgetTemplate from "@/components/Widgets/Templates/WidgetTemplate.vue";

const TASKS_PATH = "/cases/tasks/";

const LIST_CLASS = "list";

const ICONS = {
  plus: "add-outline",
};

@Component({
  components: {
    WidgetTemplate,
    PricingRequestsPopups: () => import("@/modules/Pricing/Requests/PricingRequestsPopups.vue"),
  },
})
export default class HelloEmployerWidget extends Vue {
  @Prop({ type: String }) readonly title?: string;
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: [Array, Object] }) readonly list?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Boolean, default: false }) readonly tasksEnable?: boolean;
  @Prop({ type: Boolean, default: false }) readonly getDependantVisaEnable?: boolean;
  @Prop({ type: String }) readonly image?: string;
  @Prop({ type: String }) readonly backgroundImage?: string;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get tasks() {
    if (!this.tasksEnable) return [];

    return SMUser.isEmployer
      ? SMTasksServices.employerTasksToDo
      : SMTasksServices.candidateTasksToDo;
  }

  get listClasses() {
    const { listType } = this;

    return {
      [`${LIST_CLASS}_${listType}`]: !!listType,
    };
  }

  openFirstToDoTask() {
    if (!this.tasks.length) return;

    const task: TTask_Table = this.tasks[0];

    const { id } = task;

    this.$router.push(`${TASKS_PATH}${id}`);
  }

  get dependentVisaButtonProps() {
    return {
      iconLeft: ICONS.plus,
    };
  }

  // getDependentVisa() {
  //   this.$root.$emit("get-dependant-visa", {
  //     serviceId: SMCases.caseId,
  //   });
  // }

  mounted() {
    if (SMUser.isEmployee && !this.dependantsList?.length) {
      SMAdditionalInfo.fetchDependantsList();
    }
  }

  get isEmployee() {
    return SMUser.isEmployee;
  }

  get dependantsList() {
    return SMAdditionalInfo.dependantsList;
  }

  getDependentVisa() {
    SMAdditionalInfo.buySWDependantVisa();
  }
}
